import { restApi } from '../../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../../../lib/loopback'
import { createQueryString } from '../../../../utils/Repository'

const queryTransform = {
  ...paginate
}

const validacaoFacialRepository = createRepository({
  path: 'validacao-facial',
  restApi,
  queryTransform: {
    ...paginate
  }
})

validacaoFacialRepository.manualFetch = ({ solicitacaoId, cpf }) =>
  restApi.post(`/validacao-facial/manual-fetch/${solicitacaoId}`, {
    cpf
  })

validacaoFacialRepository.list = ({ query, paginate, options } = {}) => {
  const queryString = createQueryString(query, paginate, queryTransform)
  return restApi.get('/validacao-facial' + queryString, {}, options)
}

export default validacaoFacialRepository
